var labels = {
	'007': '7 days',
	'030': '1 month',
	'090': '3 months',
	'180': '6 months',
	'365': 'Year',
	'999': 'All time',
}

Vue.component('insight', {
	props: ['insight'],
	data() {
		return {
			showActions: false,
		}
	},
	computed: {
		numMentions() {
			try {
				return this.insight.period_stats[this.insight.period_stats.length - 1].count_number
			} catch(err) {
				return 0
			}
		},
		quoteText() {
			if (this.insight.quote) {
				return this.insight.quote
			} else {
				return "<em>No recent quote was found</em>"
			}
		},
		impactExplanation() {

			let message = ''


			if (this.insight.kind == 'negative') {
				
				let diff = (this.insight.impacts.reviews_with_impact.average_rating
					- this.insight.impacts.reviews_all.average_rating) / 20
				let avg = this.insight.impacts.reviews_with_impact.average_rating / 20
				let total_avg = (avg - diff).toFixed(1)
				avg = avg.toFixed(1)

				message = 'The average rating for reviews with negative'
					+ ' mentions about "' + this.insight.term_keyword + '"'
					+ ' is ' + avg + ' vs ' + total_avg  + '.'
			}

			return message
		},
		weightExplanation() {
			let message = 'This insight makes up for ' + this.insightWeight
				+ '% of all ' + this.insight.kind + ' insights.'
			return message
		},
		insightWeight() {
			if (this.insight.score_as_percentage < 1) {
				return '< 1'
			} else {
				return this.insight.score_as_percentage.toFixed(1)
			}
		},
		kindTitle() {
			return this.insight.kind.toUpperCase()
		},
		periodLabels() {
			let str = ""
			
			let periods = this.insight.period_types.split(",")
			for (type in periods) {
				
				let period_type = periods[type]
				let delim = ", "

				if (type == periods.length - 2 && type != 0) {
					delim = " & "
				} else if (type == periods.length - 1) {
					delim = ""
				}

				str += labels[period_type] + delim + " "
			}

			return str
		}
	},
	methods: {
		viewTrendsChart() {

      analytics.track("View Insight Trends", {
        insight_id: this.insight.id,
        team_id: Spark.state.currentTeam.id,
        term_topic: this.insight.term_keyword
      })

			this.$parent.$emit('showTrendModal', this.insight)
		},
		viewPeriodBreakdown() {
      
      analytics.track("View Insight Breakdown", {
        insight_id: this.insight.id,
        team_id: Spark.state.currentTeam.id,
        term_topic: this.insight.term_keyword
      })

			this.$parent.$emit('showPeriodModal', this.insight)
		},
		seeReviews() {

      analytics.track("View Insight Reviews", {
        insight_id: this.insight.id,
        team_id: Spark.state.currentTeam.id,
        term_topic: this.insight.term_keyword
      })

			let params = this.getOriginalReviewFilters()
			params['insightRolling'] = this.insight.id

			$('.spark-settings-tabs a[href$="#reviews"]').tab('show');
            
			params['fromDate'] = ''
			params['toDate'] = ''
			
			params['insightKeyword'] = this.insight.term_keyword
            this.$eventHub.$emit('applyFilters', params);
		}
	},
	mounted() {
		Vue.nextTick(function() {
			$('[data-toggle="tooltip"]').tooltip()
		})
	}
})

Vue.component('insight-trends-chart', {
	props: ['trends', 'responsive', 'type'],
    template: `
		<div id="trends-graph" class="modal-chart chart-scroll dragscroll" style="overflow-x: auto">
        	<div class="graph-container">
            	<canvas v-show="readyToShowChart" ref="trends_chart" :width="chartWidth" height="400"></canvas>
			</div>

        </div>`,
    computed: {
    	chartWidth() {

    		let width = this.trends ? this.trends.length * 40 : 0

    		if (width < 300) {
    			width = 1000
    		}

    		return width

		},
		readyToShowChart() {
			return this.trends
		}
    },
    data() {
    	return {
			chart: null,
    		scoreLine: {
                label: 'Score',
                type: 'line',
                hidden: true,
                data: [],
				fill: false,
				borderColor: 'rgb(0, 173, 241)',
                lineTension: 0,
                pointBackgroundColor: 'rgba(255, 255, 255, 1)',
                pointStrokeColor: 'rgba(0, 173, 241, 1)',
                pointRadius: 5,
                pointHitDetectionRadius : 15,
                pointBorderWidth: 2.5,
                yAxisID: 'y-axis-1'
            },
            negativeMentionsLine: {
            	label: 'Negative Mentions',
                type: 'line',
                hidden: false,
                data: [],
                fill: this.type == 'negative' ? '+1' : true,
                lineTension: 0,
                pointStrokeColor: 'rgba(0,0,0,0)',
                strokeColor: 'rgba(0,0,0,0)',
                borderColor: 'rgba(0,0,0,0)',
                yAxisID: 'y-axis-2',
                categoryPercentage: 0.3,
                backgroundColor: '#000',
                pointBackgroundColor: 'rgba(255, 255, 255, 0)'
            },
            positiveMentionsLine: {
            	label: 'Positive Mentions',
                type: 'line',
                data: [],
                hidden: false,
                fill: true,
                lineTension: 0,
                pointStrokeColor: 'rgba(0,0,0,0)',
                strokeColor: 'rgba(0,0,0,0)',
                borderColor: 'rgba(0,0,0,0)',
                yAxisID: 'y-axis-2',
                categoryPercentage: 0.3,
                backgroundColor: '#000',
                pointBackgroundColor: 'rgba(255, 255, 255, 0)'
			},
			allMentionsLine: {
            	label: 'All Mentions',
                type: 'line',
                data: [],
                fill: true,
                lineTension: 0,
                pointStrokeColor: 'rgba(0,0,0,0)',
                strokeColor: 'rgba(0,0,0,0)',
                borderColor: 'rgba(0,0,0,0)',
                yAxisID: 'y-axis-2',
                categoryPercentage: 0.3,
                backgroundColor: '#000',
                pointBackgroundColor: 'rgba(255, 255, 255, 0)'
            }

    	}
    },
    watch: {
    	trends: function (newValue, oldValue) {

    		var instance = this
        
        if ( instance.chart) { instance.chart.destroy(); }

    		Vue.nextTick(function () {
				  chart = instance.$refs.trends_chart
    			instance.prepareChart(chart)
    			instance.prepareChartData()
    		})
    		
    	}
    },
	methods: {
		prepareChartData() {

			this.chart.data.labels = []
			this.chart.data.datasets[0].data = []
			this.chart.data.datasets[1].data = []
			this.chart.data.datasets[2].data = []
			this.chart.data.datasets[3].data = []

			this.chart.data.datasets[0].pointBorderColor = []

			var i = 0
			for (trend of this.trends) {
				this.chart.data.labels.push(trend.period)
				this.chart.data.datasets[0].data.push(trend.average_sentiment_score)
				this.chart.data.datasets[1].data.push(trend.number_of_negative_mentions)
				this.chart.data.datasets[2].data.push(trend.number_of_positive_mentions)
				this.chart.data.datasets[3].data.push(trend.number_of_mentions)

				if ( trend.number_of_mentions == 0 ) {
					this.chart.data.datasets[0].pointBorderColor[i] = 'lightgrey'
				}
				else {
					this.chart.data.datasets[0].pointBorderColor[i] = 'rgb(0, 173, 241)'
				}

				i++
			}

			this.chart.update()
		},
		prepareChart(area) {

      let ctx = area.getContext("2d")
      let negative_gradient = ctx.createLinearGradient(0, 0, 0, 400)  
      let positive_gradient = ctx.createLinearGradient(0, 0, 0, 400)
      let all_gradient = ctx.createLinearGradient(0, 0, 0, 400)
      var vue_instance = this
      var isDrawn = false;

      negative_gradient.addColorStop(0, 'rgba(205, 53, 55, 0.34)')
      negative_gradient.addColorStop(1, 'rgba(255, 128, 104, 0.34)')

      positive_gradient.addColorStop(0, 'rgba(41, 169, 7, 0.34)')
      positive_gradient.addColorStop(1, 'rgba(145, 224, 132, 0.34)')

      all_gradient.addColorStop(0, 'rgb(204, 215, 234, 0.34)')
      all_gradient.addColorStop(1, 'rgba(67, 70, 76, 0.34)')

      this.negativeMentionsLine.backgroundColor = negative_gradient
      this.positiveMentionsLine.backgroundColor = positive_gradient
      this.allMentionsLine.backgroundColor = all_gradient
      
      // Hide irrelevant sets
      this.negativeMentionsLine.hidden = this.type === 'positive'
      this.positiveMentionsLine.hidden = this.type === 'negative'

			this.chart = new Chart(area, {
                type: 'line',
                data: {
                    labels: [],
                    datasets: [this.scoreLine, this.negativeMentionsLine, this.positiveMentionsLine, this.allMentionsLine]
                },
                options: {
                	responsive: this.responsive,
					maintainAspectRatio: false,
					legend: {
						display: true,
						position: 'bottom',
					},
                    scales : {
                        yAxes : [
                            {
                                type: 'linear',
                                id: 'y-axis-1',
                                ticks : {
                                    max: 100,
                                    stepSize: 10,
                                    beginAtZero: true,
                                    fontColor: '#2c2d49'
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: 'S C O R E',
                                    fontColor: '#2c2d49'
                                },
                                gridLines: {
                                    color: "#f2f2f2"
                                }
                            },
                            {
                                ticks: {
                                    // max: 5,
                                    beginAtZero: true,
                                    fontColor: '#2c2d49',
                                    stepSize: 5
                                },
                                scaleLabel: {
                                    display: true,
                                    labelString: 'N U M B E R  O F  M E N T I O N S',
                                    fontColor: '#2c2d49'
                                },
                                position: 'right',
                                type: 'linear',
                                id: 'y-axis-2',
                                gridLines: {
                                    display: false,
                                    color: "#f2f2f2"
                                }
                            }
                        ],
                        xAxes : [
                            {
                                display: false,
                                scaleLabel: {
                                    display: true,
                                    labelString: 'T I M E'
                                },
                                gridLines: {
                                    display: false
                                }
                            },
                            {
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {

                        // Disable the on-canvas tooltip
                        enabled: true,
                        intersect: false,

                        custom: function(tooltipModel) {


                            // If there's a title attribute that means a change 
                            // in the model so we replace the current one
                            if (tooltipModel.title && tooltipModel.dataPoints.length == 1
                                    && tooltipModel.dataPoints[0].datasetIndex == 0) {
                                vue_instance.tooltipModel = tooltipModel;
                                vue_instance.tooltipHidden = false
                            } else {
                                // If the title attribute is missing that means
                                // the user hovered out of the tooltip.
                                vue_instance.tooltipHidden = true
                            }

                            if (tooltipModel.title && tooltipModel.dataPoints.length == 1
                                    && tooltipModel.dataPoints[0].datasetIndex == 1) {
                                vue_instance.countTooltipModel = tooltipModel;
                                vue_instance.countTooltipHidden = false
                            } else {
                                vue_instance.countTooltipHidden = true
                            }
                            
                        }
					},
					animation: {
						onComplete: function() {
							if (! isDrawn ) {
								isDrawn = true;
								$('#trends-graph').scrollLeft(16000)
							}
						}
					} 
				},
        	});
		}
	}
})

Vue.component('insight-periods-breakdown', {
	props: ['insight'],
	template: `
		<div class="justify-content-between period-breakdown">
			<div v-for="(stats, index) in insight.period_stats" class="period-stat" :class="{odd: (index + 1) % 2 != 0, even: (index + 1) % 2 == 0}">
				<div class="period-stat-inner">
					<h5 class="header-case">{{ labelize(stats) }}</h5>
					<p class="clearfix">
						<span class="blue-text times">{{ stats.count_number }}</span>
						<span class="light-text">Times Spotted</span>
					</p>
				</div>
			</div>
		</div>
	`,
	methods: {
		labelize(stats) {
			let prefix = ''

			if (stats.period_type != '999') {
				prefix = 'LAST '
			}

			return prefix + labels[stats.period_type]
		}
	}

})

Vue.component('impact-details', {
	props: ['impacts', 'insight_kind'],
	template: `
		<span class="impact-details">
			<strong 
				:class="{'text-success': insight_kind == 'positive', 'text-danger': insight_kind == 'negative'}">
				{{ totalImpact }}
			</strong>
			<span class="light-text">/5</span>
			<strong 
				:class="{'text-success': insight_kind == 'positive', 'text-danger': insight_kind == 'negative'}">
				<i 
				:class="{'ei-arrow_up': insight_kind == 'positive', 'ei-arrow_down': insight_kind == 'negative'}">										
				</i>	
				{{ totalImpactPrc }}%
			</strong>
		</span>
	`,
	computed: {
		keywordImpact() {
			try {
				return this.impacts.reviews_all.impacts.reviews_with_keyword.impact_diff
			} catch(error) {
				return 0
			}
		},
		keywordImpactPrc() {
			try {
				return this.impacts.reviews_all.impacts.reviews_with_keyword.impact_diff_prc
			} catch(error) {
				return 0
			}
		},
		insightImpactRating() {
			try {
				return this.impacts.reviews_with_impact.average_rating
			} catch(error) {
				return 0
			} 
		},
		insightImpactDifference() {
			try {
				return this.impacts.reviews_with_impact.average_rating
					- this.impacts.reviews_all.average_rating
			} catch(error) {
				return 0
			} 
		},
		insightImpactPrc() {
			try {

				return (
					1 - (this.insightImpactRating
					/ this.impacts.reviews_all.average_rating)
				) * 100
			} catch(error) {
				return 0
			} 
		},
		impactType() {
			 return this.keywordImpact > 0 ? 'positive' : 'negative'
		},
		totalImpact() {
			
			let impact = 0

			if (this.impactType == 'negative') {
				impact = this.keywordImpact
			} else {
				impact = this.insightImpactDifference
			}

			// TEsting
			impact = this.insightImpactDifference

			return (impact / 20).toFixed(1)

		},
		totalImpactPrc() {
			let impactPrc = 0

			if (this.impactType == 'negative') {
				impactPrc = this.keywordImpactPrc
			} else {
				impactPrc = this.insightImpactPrc
			}

			impactPrc = this.insightImpactPrc

			let sign = this.insight_kind == 'negative' ? '-' : '+'

			return sign + impactPrc.toFixed(1)
		}
	}
})